import { IoWarningOutline } from "react-icons/io5";
import { saveAccountCompletionAsync } from "../../../services/accountService";
import { FaCircleNotch } from "react-icons/fa";
import Toaster from "../../../components/common/Toaster";

const ActivationForm = ({ data, setData, isLoading, setLoading, onClose }) => {
  const handleActivate = async () => {
    try {
      setLoading(true);

      const account = { ...data };
      account["is_profile_completed"] = true;
      setData(account);

      await saveAccountCompletionAsync(data.id);

      Toaster.Success("Account Activated Successfully");
      onClose();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <div className="flex justify-center">
        <div>
          <div className="flex justify-center">
            <IoWarningOutline className="text-yellow-500 text-4xl" />
          </div>
          <p className="text-gray-400 text-sm mt-5">
            Are you sure you want to activate this account?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 mt-12 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button float-right hover:text-blue-400"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
            onClick={() => handleActivate()}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            Yes, activate it.
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivationForm;
